import { format, isValid, parseISO } from 'date-fns';
import { CALL_TYPE_OPTIONS } from '../config/endoTaxonomy';

/**
 * Переход в журнал ссылкой: графики открывают его в новой вкладке, и состояние drill-down
 * живёт в адресе, а не в памяти вкладки-источника.
 *
 * Читается только то, что есть в этих списках, поэтому новый ключ перехода надо добавить сюда:
 * забытый ключ не падает, а молча делает журнал шире карточки, с которой пришли. Сторож — круговой
 * тест на выдаче `buildEmployeeJournalScope`.
 */
const SINGLE_FILTERS = ['node_filter', 'employee_id', 'search', 'criterion'];
const LIST_FILTERS = ['employee_ids', 'departments'];

const CALLS_SECTION = 'calls';
const DATE_FORMAT = 'yyyy-MM-dd';

const hasValue = (value) => value !== undefined && value !== null && value !== '';

export const buildCallJournalUrl = (currentHref, filters, { dateRange, callType } = {}) => {
  const { callId, ...rest } = filters ?? {};
  const params = new URLSearchParams({ section: CALLS_SECTION });

  if (dateRange?.from) {
    params.set('date_from', format(dateRange.from, DATE_FORMAT));
  }
  if (dateRange?.to) {
    params.set('date_to', format(dateRange.to, DATE_FORMAT));
  }
  if (callType && callType !== 'all') {
    params.set('call_type', callType);
  }
  if (callId) {
    params.set('callId', callId);
  }

  Object.entries(rest).forEach(([key, value]) => {
    (Array.isArray(value) ? value : [value])
      .filter(hasValue)
      .forEach((item) => params.append(key, String(item)));
  });

  const url = new URL(currentHref);
  url.search = params.toString();
  url.hash = '';
  return url.toString();
};

/** Период из ссылки; null — в адресе его нет или он нечитаем. */
export const readLinkedDateRange = (searchParams) => {
  const from = parseISO(searchParams.get('date_from') ?? '');
  const to = parseISO(searchParams.get('date_to') ?? '');

  return isValid(from) && isValid(to) && from <= to ? { from, to } : null;
};

/** Направление из ссылки; значение вне перечисления равно его отсутствию. */
export const readLinkedCallType = (searchParams) => {
  const callType = searchParams.get('call_type');

  return CALL_TYPE_OPTIONS.some(({ code }) => code === callType) ? callType : null;
};

/** Фильтры перехода для журнала; другим разделам они ни о чём не говорят. */
export const readLinkedJournalFilters = (searchParams) => {
  if (searchParams.get('section') !== CALLS_SECTION) {
    return null;
  }

  const filters = {};
  SINGLE_FILTERS.filter((key) => hasValue(searchParams.get(key))).forEach((key) => {
    filters[key] = searchParams.get(key);
  });
  LIST_FILTERS.filter((key) => searchParams.getAll(key).some(hasValue)).forEach((key) => {
    filters[key] = searchParams.getAll(key).filter(hasValue);
  });

  const maxScore = Number.parseFloat(searchParams.get('criterion_max_score'));
  if (Number.isFinite(maxScore)) {
    filters.criterion_max_score = maxScore;
  }

  return Object.keys(filters).length > 0 ? filters : null;
};
